import React from 'react';

import { cn } from '../../utils/classname';
import './kaleidoscope.scss';

export const Kaleidoscope = ({ className }) => {
  return (
    <div className={cn('rc-kaleidoscope-wrapper', className)}>
      {new Array(16).fill(null).map((a, i) => (
        <div className={`rc-kaleidoscope__tile ${i + 1}`} key={i}>
          <div className="rc-kaleidoscope__tile-image" />
        </div>
      ))}

      <div className="rc-kaleidoscope__icon">
        <img src="https://www.siteground.com/static/en/img/recap2023/browser_animation.png" alt="" />
      </div>
    </div>
  );
};
